import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TokenAuth, UserDTO } from 'src/dto/users/users-dto';
import { clearLocalStorage, decryptToObject } from 'src/services/environment';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent {

  constructor(private router: Router) {
  }

  onReturnButton() {
    const user: TokenAuth = JSON.parse(decryptToObject(localStorage.getItem('CurrentUser')));
    if (user == null) {
      this.router.navigate(['/login']);
    }

    switch (user.roles[0]) {
      case 'SUPER_ADMIN':
        this.router.navigate(['/pim']);
        break;

      case 'ADMIN':
        this.router.navigate(['/pim']);
        break;

      case 'PIM':
        this.router.navigate(['/pim']);
        break;

      case 'DAM':
        this.router.navigate(['/dam']);
        break;

      case 'CATALOG':
        this.router.navigate(['/catalogues']);
        break;

      case 'MEDIA_MANAGER':
        this.router.navigate(['/dam']);
        break;

      case 'GLRY_VIEW':
        this.router.navigate(['/login']);
        break;

      default:
        clearLocalStorage();
        this.router.navigate(['/login']);
        break;
    }
  }

}
